import { useState } from 'react'
import { useForgotPassword } from './commands'
import { ForgotPasswordFormValues } from './components'
import { ForgotPasswordScreen } from './forgot-password-screen'

export const ForgotPasswordScreenContainer = () => {
  const [completed, setCompleted] = useState(false)
  const [mutate, { loading, error }] = useForgotPassword()

  const handleSubmit = async (values: ForgotPasswordFormValues) => {
    try {
      await mutate({
        variables: {
          email: values.email,
        },

        onCompleted: async (data) => {
          if (!data?.forgotPasswordUser) {
            return
          }
          setCompleted(true)
        },
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <ForgotPasswordScreen
      loading={loading}
      error={error?.message}
      completed={completed}
      onSubmit={handleSubmit}
    />
  )
}
